import { render, staticRenderFns } from "./bindMechanism.vue?vue&type=template&id=406b3a9a&scoped=true&"
import script from "./bindMechanism.vue?vue&type=script&lang=js&"
export * from "./bindMechanism.vue?vue&type=script&lang=js&"
import style0 from "./bindMechanism.vue?vue&type=style&index=0&id=406b3a9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406b3a9a",
  null
  
)

export default component.exports